var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mconarall"},[_c('Header',{attrs:{"header":_vm.header}}),_c(_vm.currentComponent,{tag:"component",model:{value:(_vm.querylist),callback:function ($$v) {_vm.querylist=$$v},expression:"querylist"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }